/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import {
	DatePickerInputNew,
	InputDevicesGroup,
	InputGroups,
	InputParentGroup,
} from "../../../../Helpers/Input/Input";
import Button from "../../../../Helpers/Button/Button";
import { useLocation, useParams } from "react-router-dom";
import { useLazyGetHistoryPositionQuery } from "../../../../../Redux/service/Positions";
import { useDispatch, useSelector } from "react-redux";
import { setHistoryPositions } from "../../../../../Redux/service/Websocket";
import { useMap } from "react-leaflet";
import { toast } from "react-toastify";
import { popupcontext } from "../../../../../context/Popupscontext";
import { toLocalISOString } from "../../../../../JsHelpers/DateFormat";
import trans from "../../../../../utils";

export default function PlayBackDate({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	vid,
	setVId,
	media,
	setMedia,
}) {
	const inf = useSelector((state) => state.users.user);
	const [uid, setUId] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const { pathname } = useLocation();
	const getShortPath = () => pathname.split("/").pop();

	const { setDisplay, setShow, handleClose, setPosIndex, setHistoryPlayback } =
		useContext(popupcontext);
	let { id } = useParams();
	let [getHistPos] = useLazyGetHistoryPositionQuery();
	const map = useMap();
	const dispatch = useDispatch();

	const handleDateRangeChange = ({ startDate, endDate }) => {
		setStartDate(startDate ? toLocalISOString(new Date(startDate)) : null);
		setEndDate(endDate ? toLocalISOString(new Date(endDate)) : null);
	};

	const handleVehicleIdChange = (value) => {
		setVId(value);
	};

	const handleUserIdChange = (value) => {
		setUId(value);
	};

	const handleResetData = () => {
		setMedia(false);
		setStartDate("");
		setEndDate("");
		setPosIndex(0);
		handleClose("historyPlayBack");
		dispatch(setHistoryPositions([]));
		setHistoryPlayback({ state: false, Id: 0 });
	};
	const handleFetchData = async () => {
		if ((id || vid) && startDate && endDate) {
			setIsLoading(true);

			map.dragging.enable();
			const response = await getHistPos({
				deviceId: id || vid,
				from: startDate,
				to: endDate,
			});

			if (response?.data.length > 0) {
				setShow({ type: "playbacktrip", value: true });

				setDisplay(true);
				setIsLoading(false);
				dispatch(setHistoryPositions(response.data));
				setMedia(true);
				map.setView(
					[response.data[0]?.latitude, response.data[0]?.longitude],
					22
				);
			} else if (response?.data.length === 0) {
				setIsLoading(false);
				toast.error(trans("No Data Found"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else {
				setIsLoading(false);
				toast.error(trans("Error fetching data"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		} else {
			toast.error(trans("Please Fill Inputs First"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};

	useEffect(() => {
		if (isLoading) {
			const loadingToastId = toast.info(trans("Loading, please wait..."), {
				autoClose: false,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return () => toast.dismiss(loadingToastId); // Clear the loading toast on unmount
		}
	}, [isLoading]);
	return (
		<div>
			{!media && (
				<div className="history-playback-dateinput">
					{getShortPath(pathname) === "historical" && (
						<>
							<InputGroups
								id="parent"
								name="parent"
								title={trans("Groups")}
								formstyle="w-100 mb-2"
								value={uid}
								onChange={handleUserIdChange}
							/>
							<InputDevicesGroup
								title={trans("Vehicle")}
								formstyle="w-100 mb-2"
								placeholder={trans("Select Vehicle")}
								value={vid || ""}
								userID={uid}
								onChange={handleVehicleIdChange}
							/>
						</>
					)}
					<DatePickerInputNew
						id="dateRange"
						name="dateRange"
						title={trans("Date Range")}
						formstyle="form-input"
						onChange={handleDateRangeChange}
					/>
					<div className="history-playback-footer">
						<Button
							htmlType="button"
							type={media ? "default" : "primary"}
							text={media ? trans("Reset") : trans("Show")}
							onClick={media ? handleResetData : handleFetchData}
						/>
					</div>
				</div>
			)}
			{/**<div className="text-center">
        {media && histData?.length > 0 && (
          <>
            <PlayBackControls maxValue={histData?.length} />
          </>
        )}
      </div>**/}
		</div>
	);
}
